import { call, put, select } from 'redux-saga/effects';
import { config } from '../../api/config';
import { Api } from '../../api/api';
import { actions } from '..';
import { downloadFile, errorMessage } from '../../utils';
import { selectBannerImage } from '../selectors';

export function* getBannersSaga({ filter: initialFilter = {} }) {
  try {
    yield put(actions.banners.setBannersLoadingAction(true));

    const body = {
      ...initialFilter,
      limit: initialFilter.limit || config.DEFAULTS.recordsPerPage,
    };

    const { announcements, count } = yield call(Api.getBanners, body);

    yield put(actions.banners.setBannersAction(announcements || [], count));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannersLoadingAction(false));
  }
}

export function* getBannerSaga({ id }) {
  try {
    yield put(actions.banners.setBannersLoadingAction(true));

    const banner = yield call(Api.getBanner, id);

    yield put(actions.banners.setBannerAction(banner));
    yield put(
      actions.banners.setBannerImageAction(banner.banner || banner.image || {})
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannersLoadingAction(false));
  }
}

export function* addBannerSaga({ body, history }) {
  try {
    yield put(actions.banners.setBannersLoadingAction(true));

    const image = yield select(selectBannerImage);
    const finalBody = {
      ...body,
      banner_id: image?.id || null,
    };

    yield call(Api.addBanner, finalBody);
    history.push(config.APP_PATHS.banners);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannersLoadingAction(false));
  }
}

export function* editBannerSaga({ id, body, history }) {
  try {
    yield put(actions.banners.setBannersLoadingAction(true));

    const image = yield select(selectBannerImage);
    const finalBody = {
      ...body,
      banner_id: image?.id || null,
    };

    yield call(Api.editBanner, id, finalBody);
    history.push(config.APP_PATHS.banners);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannersLoadingAction(false));
  }
}

export function* exportBannersSaga({ filename }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));

    const response = yield call(Api.exportBanners);

    downloadFile(response, filename);
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* uploadBannerImageSaga({ file }) {
  try {
    yield put(actions.banners.setBannerImageUploadingAction(true));

    if (!file) {
      yield put(actions.banners.setBannerImageAction({}));
      return;
    }

    const data = yield call(Api.uploadBannerImage, file);

    yield put(actions.banners.setBannerImageAction(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannerImageUploadingAction(false));
  }
}

export function* updateBannerPrioritySaga({ id, direction, filter }) {
  try {
    yield put(actions.banners.setBannersLoadingAction(true));

    yield call(Api.updateBannerPriority, id, direction);

    yield put(actions.banners.getBannersAction(filter));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.banners.setBannersLoadingAction(false));
  }
}
